'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Base dialog type displays dialog as either modal or drawer, and which is the heart of the dialog component
 * @param props DialogTypeProps
 */ const DialogType = (props)=>{
    const { animation , 'aria-labelledby': ariaLabelledBy , children , className , height , id , size , style , type , width , ...otherProps } = props;
    // position is used for drawer dialogs
    // fade-in-from-left => left
    // fade-in-from-right => right
    const position = animation.split('-').pop();
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, otherProps, {
        "aria-labelledby": ariaLabelledBy,
        "aria-modal": true,
        className: classnames__default.default({
            'bf-dialog__type': true,
            [`bf-dialog__type--${type}`]: type,
            [`bf-dialog__type--animation-${animation}`]: animation,
            [`bf-dialog__type--position-${position}`]: position,
            [`bf-dialog__type--size-${size}`]: size,
            [`${className}`]: !!className
        }),
        id: id,
        role: "dialog",
        style: {
            ...style,
            height: height !== undefined && height > 0 ? height : undefined,
            width: width !== undefined && width > 0 ? width : undefined
        }
    }), children);
};

exports.DialogType = DialogType;
//# sourceMappingURL=dialog-type.js.map
